import React from "react";

const Minigames = () => {
  return (
    <>
      {/* <div className="payment-icon-box-container">
        <div className="payment-icon-box">
          <div className="align-items-center d-flex justify-content-between">
            <div className="align-items-center">
              <h4>BANK</h4>
              <span>100 - 5Lac</span>
            </div>
            <div>
              <div className="d-flex justify-content-end mb-3">
                <button className="place-bet-btn">Benificiary Accounts</button>
              </div>
            </div>
          </div>
          <div className="row manual-container-qr payment-details-box">
            <div className="col-12 col-sm-12 col-md-12">
              <div className="row">
                <div className="col-12 col-sm-3 col-md-3">
                  <label htmlFor="inputPassword5" className="form-label">
                    Account Holder Name:
                  </label>
                  <input
                    disabled=""
                    className="form-control"
                    type="text"
                    placeholder="Enter Account Holder Name"
                    aria-label="Disabled input example"
                    name="accountHolderName"
                    defaultValue=""
                  />
                </div>
                <div className="col-12 col-sm-3 col-md-3">
                  <label htmlFor="inputPassword5" className="form-label">
                    Account Number:
                  </label>
                  <input
                    disabled=""
                    className="form-control"
                    type="text"
                    placeholder="Enter Account Number"
                    aria-label="Disabled input example"
                    name="accountNumber"
                    defaultValue=""
                  />
                </div>
                <div className="col-12 col-sm-3 col-md-3">
                  <label htmlFor="inputPassword5" className="form-label">
                    IFSC Code:
                  </label>
                  <input
                    disabled=""
                    type="text"
                    id="disabledTextInput"
                    className="form-control"
                    placeholder="Enter IFSC Code"
                    name="iFSCCode"
                    defaultValue=""
                  />
                </div>
                <div className="col-12 col-sm-3 col-md-3">
                  <label htmlFor="inputPassword5" className="form-label">
                    Amount:
                  </label>
                  <input
                    type="text"
                    id="disabledTextInput"
                    className="form-control"
                    placeholder=""
                    disabled=""
                    defaultValue={5000}
                  />
                </div>
                <div className="col-12 col-sm-3 col-md-3 mt-2">
                  <div className="mt-1">
                    <button className="btn btn-payment-submit" disabled="">
                      Withdraw
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Minigames;
